import {useForm} from "react-hook-form";
import {useEffect, useState} from "react";
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {setValidationMessage} from "../../util/validationMessage";
import Modal from "../../components/UI/Modal";
import Input from "../../components/UI/form/Input";
import Button from "../../components/UI/Button";
import {storeWithdrawRequest} from "../../api/commissionTransaction";
import {checkPermission} from "../../util/auth";

const WithdrawRequestForm = ({commissionInfo = null, openModal,  setOpenModal}) =>{
  const queryClient = useQueryClient()

  const {getValues, setValue, watch, reset, register, setError, clearErrors, handleSubmit, formState: { errors }} = useForm({
    defaultValues: {},
  });

  useEffect(() => {
    reset();
  }, [openModal, commissionInfo]);

  const [toastId, setToastId] = useState(null);

  const { isPending, mutate } = useMutation({
    mutationFn: (formData) => storeWithdrawRequest(formData),
    onMutate: () => {
      setToastId(toast.loading("Please wait..."));
      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === 'commissionBalance',
      });
    },
    onSuccess: (res) => {
      toast.update(toastId, {
        render: "Withdraw Request Submitted",
        type: "success",
        isLoading: false,
        autoClose: true
      });

      setOpenModal(false);
      reset();
    },
    onError: (error) => {
      let errorMsg = "Something happened!";
      if (error && error.message && error.message.errors) {
        setValidationMessage(error.message.errors, setError);
        errorMsg = error.message.message;
      }
      if (error.message.message) {
        errorMsg = error?.message?.message
      }

      toast.update(toastId, {
        render: errorMsg,
        type: "error",
        isLoading: false,
        autoClose: true
      });
    }
  });

  const onSubmit = (data) => {
    clearErrors();
    let formData = new FormData();
    Object.keys(data).forEach(key => {
      formData.append(key, data[key] ? data[key] : '');
    });
    mutate(formData);
  };

  return(
    <>
      <Modal title={`Withdraw Request`} open={openModal} setOpen={setOpenModal}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col_12">
              <p>Available balance: ${commissionInfo?.withdrawable_amount?.toFixed(2)}</p>
              <Input label="Amount"
                     name="withdraw_amount"
                     type="number"
                     errors={errors}
                     validationRules={{required: true, type: 'number', max: commissionInfo?.withdrawable_amount}}
                     register={register}/>
            </div>
            {checkPermission(['WITHDRAW_REQUEST']) &&
            <div className="col_12">
              <div className="d_flex_end">
                <Button
                  text="submit"
                  isPending={isPending}
                  type={"submit"}
                />
              </div>
            </div>
            }
          </div>
        </form>
      </Modal>
    </>
  );
}

export default WithdrawRequestForm;